module.exports = __webpack_public_path__ + "media/images/qc-bk-a6ffe5264433aaac00a8a92d1b962551.jpg";